<!--
  - Copyright (c) ProviderTrust LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - ProviderTrust LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with ProviderTrust.
  -->

<template>
  <div>
    <h2 class="header-title">{{ title }}</h2>

    <div class="app-search-type-list">
      <div class="app-search-type">
        <v-checkbox
          :ripple="false"
          label="Search exclusions by name"
          v-model="selectedOptions"
          value="NAME"
          :disabled="disabledOptions.includes('NAME')"
        />
        <span class="app-price">$0.15/search</span>
      </div>

      <div class="app-search-type">
        <v-checkbox
          :ripple="false"
          hint="Added on to searching exclusions by name"
          :persistent-hint="true"
          label="OFAC add-on"
          v-model="selectedOptions"
          value="OFAC"
          :disabled="disabledOptions.includes('OFAC')"
        />
        <span class="app-price">$0.05/search</span>
      </div>

      <div class="app-search-type">
        <v-checkbox
          :ripple="false"
          label="Search exclusions by NPI"
          v-model="selectedOptions"
          value="NPI"
          :disabled="disabledOptions.includes('NPI')"
        />
        <span class="app-price">$0.20/search</span>
      </div>

      <div class="app-search-type">
        <v-checkbox
          :ripple="false"
          label="Search SSNDMF"
          v-model="selectedOptions"
          value="SSNDMF"
          :disabled="disabledOptions.includes('SSNDMF')"
        />
        <span class="app-price">$0.05/search</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchOptions",
  model: {
    prop: "options",
    event: "change"
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      required: true
    },
    disabledOptions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    selectedOptions: {
      get() {
        return this.options
      },
      set(newValue) {
        this.$emit("change", newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.header-title {
  font-weight: $heavy;
  margin-bottom: 1.5rem;
}
.app-search-type-list {
  max-width: 26rem;
  font-size: 1.2rem;
  margin: 0 auto;
}

.app-search-type {
  font-weight: bold;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;

  .app-price {
    font-weight: 100;
    color: $color-ec-darker-gray;
  }

  /deep/ .v-input--checkbox {
    margin-top: 0;
    padding-top: 0;

    .v-messages {
      position: relative;
      left: 2rem;
      top: -0.75rem;
      font-weight: $normal;
      font-size: 0.9rem;
      font-style: italic;
      color: $color-ec-darker-gray;
      min-height: 0;
    }
  }
}
</style>
<style lang="scss">
.app-search-type {
  color: black;

  .v-icon--selection-control {
    display: flex;
    transition-duration: 0s !important;
  }

  label {
    font-size: 1.15rem;
  }

  .v-input--is-label-active {
    &:not(.v-input--is-disabled) {
      color: $color-ec-light-blue !important;
    }
    &.v-input--is-disabled {
      color: $color-ec-darker-gray !important;
      .v-icon {
        color: $color-ec-checkbox-gray !important;
      }
    }

    label {
      color: $color-ec-darker-gray !important;
    }
  }

  i {
    font-size: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SearchOptions.vue